import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import {
  reconciliationReportData,
  reconciliationReportWithPaymentStatus,
  reconciliationPaymentStatusUpdateResponse
} from '../mockData/reconciliationReportData';

export const reconciliationReportHandler: RestHandler[] = [
  rest.get(PATHS.getAccountingVirtualCardPayment(), (_, res, ctx) => {
    const paymentStatus = _.url.searchParams.get('statuses');
    if (paymentStatus) {
      return res(
        ctx.json(reconciliationReportWithPaymentStatus(paymentStatus))
      );
    }
    return res(ctx.status(200), ctx.json(reconciliationReportData));
  }),

  rest.put(PATHS.getAccountingVirtualCardPaymentStatus(), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(reconciliationPaymentStatusUpdateResponse))
  )
];
